<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() }}</h2>
            <p>Manage regional offices (RO). Each RO maps to a client's master policy.</p>
        </div>
        <p-button label="Add RO" icon="pi pi-plus" (onClick)="openAdd()" />
    </div>

    <div class="card">
        <div class="toolbar">
            <p-iconfield iconPosition="left" class="search-field">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" pInputText placeholder="Search RO, zone, state or policy number..."
                    [ngModel]="search()" (ngModelChange)="search.set($event)">
            </p-iconfield>
            <p-select [options]="clientFilterOptions()" [ngModel]="filterClientId()"
                (ngModelChange)="filterClientId.set($event)" optionLabel="label" optionValue="value"
                placeholder="Filter by client" appendTo="body" styleClass="client-filter" />
            <span class="count">{{ filtered().length }} of {{ rows().length }}</span>
        </div>

        <p-table [value]="filtered()" [loading]="loading()" dataKey="id" [rows]="10"
            [paginator]="filtered().length > 10" [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th>RO Code</th>
                    <th>RO Name</th>
                    <th>Zone</th>
                    <th>State</th>
                    <th>Master Policy No.</th>
                    <th>Client</th>
                    <th>Status</th>
                    <th class="ta-r">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-r>
                <tr>
                    <td class="mono">{{ r.roCode }}</td>
                    <td class="name">{{ r.roName }}</td>
                    <td>{{ r.zoneName || '—' }}</td>
                    <td>{{ r.stateNames || r.stateName || '—' }}</td>
                    <td class="mono">{{ r.masterPolicyNumber || '—' }}</td>
                    <td>{{ r.clientName || '—' }}</td>
                    <td>
                        <p-tag [value]="r.isActive ? 'ACTIVE' : 'INACTIVE'"
                            [severity]="r.isActive ? 'success' : 'secondary'"
                            (click)="toggleActive(r)" styleClass="clickable" pTooltip="Click to toggle" />
                    </td>
                    <td class="ta-r actions">
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Edit" (onClick)="openEdit(r)" />
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                            pTooltip="Delete" (onClick)="remove(r)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">
                        <div class="state"><i class="pi pi-inbox"></i><p>No regional offices found.</p></div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    [header]="editing() ? 'Edit Regional Office' : 'Add Regional Office'" styleClass="menu-dialog"
    [style]="{ width: '560px' }" [breakpoints]="{ '560px': '94vw' }">
    <form [formGroup]="form" class="menu-form">
        <div class="field">
            <label>Client <span class="req">*</span></label>
            <p-select formControlName="clientId" [options]="clientOptions()" optionLabel="label"
                optionValue="value" [filter]="true" placeholder="Select client" appendTo="body" />
            @if (form.get('clientId')?.touched && form.get('clientId')?.invalid) {
                <small class="err">Client is required</small>
            }
        </div>

        <div class="grid-2">
            <div class="field">
                <label>RO Code <span class="req">*</span></label>
                <input pInputText type="text" formControlName="roCode" placeholder="e.g. RO19">
                @if (form.get('roCode')?.touched && form.get('roCode')?.invalid) {
                    <small class="err">RO code is required</small>
                }
            </div>
            <div class="field">
                <label>RO Name <span class="req">*</span></label>
                <input pInputText type="text" formControlName="roName" placeholder="e.g. JABALPUR">
                @if (form.get('roName')?.touched && form.get('roName')?.invalid) {
                    <small class="err">RO name is required</small>
                }
            </div>
        </div>

        <div class="grid-2">
            <div class="field">
                <label>Zone</label>
                <p-select formControlName="zoneId" [options]="zoneOptions()" optionLabel="label"
                    optionValue="value" [filter]="true" [showClear]="true" placeholder="Select zone" appendTo="body" />
            </div>
            <div class="field">
                <label>States</label>
                <p-multiSelect formControlName="stateIds" [options]="stateOptions()" optionLabel="label"
                    optionValue="value" [filter]="true" display="chip" [showClear]="true"
                    placeholder="Select one or more states" appendTo="body" />
                <small class="muted">One RO can cover multiple states — select all that share this regional office.</small>
            </div>
        </div>

        <div class="field">
            <label>Master Policy</label>
            <p-select formControlName="masterPolicyId" [options]="policyOptions()" optionLabel="label"
                optionValue="value" [filter]="true" [showClear]="true"
                [placeholder]="form.get('clientId')?.value ? 'Select master policy' : 'Select a client first'"
                appendTo="body" />
            <small class="hint-muted">Only master policies owned by the selected client are listed.</small>
        </div>

        <div class="field-row">
            <label>Active</label>
            <p-toggleswitch formControlName="isActive" />
        </div>

        <div class="modal-actions">
            <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
            <p-button label="Save" (onClick)="save()" [loading]="saving()" />
        </div>
    </form>
</p-dialog>
